<template>
  <v-card>
    <v-card-title class="headline">
      <layout-no-padding>
        <v-flex xs12>
          <span>Reprice selected trips?</span>
        </v-flex>
        <v-flex xs12 class="grey--text title">This action will affect {{selectedCount}} document(s).</v-flex>
      </layout-no-padding>
    </v-card-title>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn color="grey darken-1" flat @click="close()">Cancel</v-btn>
      <v-btn :color="primaryNeutral" flat @click="repriceTrips()" :loading="loading">Reprice Trips</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import DocketService from "@/services/requests/docketService";
import BuildTripQuery from "@/services/mixins/buildTripQuery";
export default {
  mixins: [BuildTripQuery],
  data() {
    return {
      loading: false
    };
  },
  methods: {
    close() {
      this.$emit("close");
    },
    repriceTrips() {
      var repriceTripsData = {};
      if (this.selectedAll) {
        //BUILD QUERY IF MODIFYING ALL TRIPS
        repriceTripsData.query = this.buildQuery();
      } else {
        //SET TRIP IDS ARRAY IF MODIFYING SELECT TRIPS
        repriceTripsData.trips = this.selected.map(trip => {
          return trip.id;
        });
      }
      this.loading = true;
      DocketService.batchRepriceTrips(repriceTripsData)
        .then(result => {
          this.snack({ color: "green", text: result.data.message });
          this.$store.commit("trips/setState", {
            prop: "fetchTrips",
            value: true
          });
          this.close();
          this.loading = false;
        })
        .catch(err => {
          this.snack({ color: "red", text: "An error occured" });
          this.loading = false;
        });
    }
  },
  props: {
    selectedCount: Number,
    selectedAll: Boolean,
    selected: Array
  }
};
</script>

<style>
</style>